import { InjectionToken } from '@angular/core';
export const WebAngularSharedUtilErrorHandlingConfig = new InjectionToken('WebAngularSharedUtilErrorHandlingConfig');
//# sourceMappingURL=error-handling-config.js.map